import React from 'react';
import {
  FormWithRedirect,
  TextInput,
  useNotify,
  useRefresh,
  useUpdate,
} from 'react-admin';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import ModalView from './ModalView';
import CustomActions from './CustomActions';
import { useCustomerDetailsStyles } from './CustomerDetails';
import DialogTitle from '../../components/DialogTitle';

const NoteEdit = ({ openEdit, setOpenEdit, customer }) => {
  const classes = useCustomerDetailsStyles();
  const [update, { loading }] = useUpdate('customer');

  const notify = useNotify();
  const refresh = useRefresh();

  const handleSubmit = (values) => {
    update(
      {
        payload: {
          id: customer.id,
          data: values,
          previousData: customer,
        },
      },
      {
        onSuccess: () => {
          setOpenEdit(false);
          notify('Customer note updated successfully');
          refresh();
        },
        onFailure: ({ error }) => {
          notify(error.message, 'warning');
        },
      },
    );
  };

  return (
    <ModalView openEdit={openEdit} setOpenEdit={setOpenEdit}>
      <DialogTitle>Notes on the Customer</DialogTitle>
      <FormWithRedirect
        resource="customer"
        record={customer}
        save={handleSubmit}
        render={(formProps) => (
          <>
            <DialogContent>
              <TextInput
                label="Notes on the Customer"
                source="admin_note"
                multiline
                fullWidth
              />
              <Typography variant="body2" className={classes.gray}>
                Notes are not visible to the customer
              </Typography>
            </DialogContent>
            <CustomActions
              {...formProps}
              setOpenEdit={setOpenEdit}
              loading={loading}
            />
          </>
        )}
      />
    </ModalView>
  );
};

export default NoteEdit;
